import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addPakketProducts } from '../../../redux/actions/productActions'
import { hideChildSideBar } from '../../../redux/actions/miscActions'
import { Form, Space, InputNumber, Select} from 'antd'

const { Option } = Select

export class PakketProducts extends Component {
  constructor(props){
    super(props);
    this.state={
      pakketProducts: []
    }
  }

  onFinish=(value)=>{
    const {selectedProducts} = value
    this.props.addPakketProducts(selectedProducts)
    // this.props.hideChildSideBar()
  }

  componentDidMount=()=>{
    const { pakketProducts } = this.props.products;
    if(pakketProducts.length > 0){
      this.setState({
        pakketProducts
      })
    }
  }
  
  render() {
    // const { pakketProducts } = this.state
    const { allClientProducts, pakketProducts } = this.props.products;
    const initialValues = {selectedProducts: pakketProducts}

    const productsSelList = [];
    allClientProducts.map((x) =>
    productsSelList.push(
      <Option key={x.id} value={x.productNaam} >
          {x.productNaam}
        </Option>
      )
    );
    return (
      <div className="pakketten-product-form">
        <Form name="dynamic_form_item" onFinish={this.onFinish} initialValues={pakketProducts.length > 0 ? initialValues : null }>

<Form.List name='selectedProducts' >
        {(fields, { add, remove }) => (
          <>
            {fields.map(field => (
              <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                <Form.Item
                  {...field}
                  name={[field.name, 'aantalNum']}
                  fieldKey={[field.fieldKey, 'aantalNum']}
                >
                  <InputNumber min={0} defaultValue={0}/>
                </Form.Item>
                <Form.Item {...field}
                name={[field.name, 'productEenheid']}
                fieldKey={[field.fieldKey, 'productEenheid']}
                >
            <Select 
            showSearch
            style={{ width: 145 }}
            placeholder="Eenheid"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
            >
              <Option value="stuk">stuk</Option>
              <Option value="hoop">hoop</Option>
              <Option value="hoop(4x)">hoop(4x)</Option>
              <Option value="hoop(8x)">hoop(8x)</Option>
              <Option value="1/2hand">1/2hand</Option>
              <Option value="takjes(4x)">takjes(4x)</Option>
              <Option value="bosje">bosje</Option>
              <Option value="pakje">pakje</Option>
            </Select>
          </Form.Item>
                <Form.Item
                  {...field}
                  name={[field.name, 'productNaam']}
                  fieldKey={[field.fieldKey, 'productNaam']}
                >
                  <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder="Product"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  >{productsSelList}</Select>
                </Form.Item>
                <button className="remove-field-button" onClick={() => remove(field.name)}> - </button>
              </Space>
            ))}
            <Form.Item>
              <button className="add-field-button" onClick={() => add()}>
                Product toevoegen
              </button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <button htmlType='submit' className="large-main-btn">Opslaan</button>
</Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  products: state.products,
  misc: state.misc,
});


export default connect(mapStateToProps, {addPakketProducts, hideChildSideBar})(PakketProducts)
